{
    "title": "Verkaufshistorie",
    "for": "für"
}
